<template>
    <div :class="`contentElement__${side}Number`">
        <span
            v-for="(word, index) in countInWords"
            :key="word"
            :class="`contentElement__${side}NumberDigit -${word}`"
        >
            {{ index + 1 }}
        </span>
    </div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {

    props: {
        side: {
            type: String,
            default: 'front',
        },
    },

    computed: {
        ...mapGetters(['keyedData']),

        countInWords () {
            return Object.keys(this.keyedData).map(key => key)
        },
    },

}
</script>
